import styled from 'styled-components';
import Heading from '../Heading';
const H5 = styled(Heading).attrs({
  tagName: 'h5'
}).withConfig({
  displayName: "H5"
})([""]);
H5.displayName = 'H5';
export default H5;